export const CREATE_ORDER_REQUEST = "CREATE_ORDER_REQUEST";
export const CREATE_ORDER_SUCCESS = "CREATE_ORDER_SUCCESS";
export const CREATE_ORDER_FAIL = "CREATE_ORDER_FAIL";
export const CREATE_ORDER_RESET = "CREATE_ORDER_RESET";


export const ALL_ORDERS_REQUEST = "ALL_ORDERS_REQUEST";
export const ALL_ORDERS_SUCCESS = "ALL_ORDERS_SUCCESS";
export const ALL_ORDERS_FAIL = "ALL_ORDERS_FAIL";

export const ORDER_DETAILS_REQUEST = "ORDER_DETAILS_REQUEST";
export const ORDER_DETAILS_SUCCESS = "ORDER_DETAILS_SUCCESS";
export const ORDER_DETAILS_FAIL = "ORDER_DETAILS_FAIL";

export const CHART_DATA_REQUEST = "CHART_DATA_REQUEST";
export const CHART_DATA_SUCCESS = "CHART_DATA_SUCCESS";
export const CHART_DATA_FAIL = "CHART_DATA_FAIL";

export const ORDER_REPORTS_REQUEST = "ORDER_REPORTS_REQUEST";
export const ORDER_REPORTS_SUCCESS = "ORDER_REPORTS_SUCCESS";
export const ORDER_REPORTS_FAIL = "ORDER_REPORTS_FAIL";

export const CREATE_REPORT_REQUEST = "CREATE_REPORT_REQUEST";
export const CREATE_REPORT_SUCCESS = "CREATE_REPORT_SUCCESS";
export const CREATE_REPORT_RESET = "CREATE_REPORT_RESET";
export const CREATE_REPORT_FAIL = "CREATE_REPORT_FAIL";

export const CREATE_REMARKS_REQUEST = "CREATE_REMARKS_REQUEST";
export const CREATE_REMARKS_SUCCESS = "CREATE_REMARKS_SUCCESS";
export const CREATE_REMARKS_RESET = "CREATE_REMARKS_RESET";
export const CREATE_REMARKS_FAIL = "CREATE_REMARKS_FAIL";

export const UPDATE_REPORT_STATUS_REQUEST = "UPDATE_REPORT_STATUS_REQUEST";
export const UPDATE_REPORT_STATUS_SUCCESS = "UPDATE_REPORT_STATUS_SUCCESS";
export const UPDATE_REPORT_STATUS_FAIL = "UPDATE_REPORT_STATUS_FAIL";
export const UPDATE_REPORT_STATUS_RESET = "UPDATE_REPORT_STATUS_RESET";

export const CLEAR_ERRORS = "CLEAR_ERRORS";
